import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { PricingRuleAction } from '@cbridge-packages/pricing-rules';
import { RulesManagementAction } from '@cbridge-modules/rules-management-page';

export const onValidatePricingRulesDoneEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(
    PricingRuleAction.validate.done,
  ),
  mergeMap((payload) => {
    return [RulesManagementAction.applyValidation(payload.result)];
  }),
);
